module.exports = __webpack_public_path__ + "img/header.6ddb6645.png";